// extracted by mini-css-extract-plugin
export var button = "account-data-module--button--3aa94";
export var form = "account-data-module--form--7f330";
export var inputEmail = "account-data-module--input-email--3d770";
export var inputFirstName = "account-data-module--input-first-name--8aa4e";
export var inputLastName = "account-data-module--input-last-name--10c85";
export var loading = "account-data-module--loading--20dca";